
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetalleEspacioPorCerealLinea3Service {
  static async getDataTablaDetalleEspacioPorCerealLinea3 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_espacio_cereal_sector3')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla Espacio por cereal sector 3.')
      return (data)
    })
  }

  static async getDataTablaDetalleEspacioPorCerealLinea3Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_espacio_cereal_sector3_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla Espacio por cereal sector 3.')
      return (data)
    })
  }
}
